import website from "./website";

const baseUrl = import.meta.env.VITE_APP_API;
const baseDir = import.meta.env.VITE_APP_BASE;
const websocketUrl = website.websocketUrl;
const imageBaseUrl = website.imageBaseUrl // 图片上传存储的路径.
const hostname = window.location.hostname;
let graphEditorUrl = `http://${hostname}:2888/grapheditor/dist/index.html`; // 组态编辑页
let graphViewerUrl = `http://${hostname}:2888/grapheditor/dist/viewer_iframe.html`; // 组态预览页
if (process.env.NODE_ENV !== 'development') {
  graphEditorUrl = `http://${hostname}:8088${baseDir}/grapheditor/dist/index.html`; // 组态编辑页
  graphViewerUrl = `http://${hostname}:8088${baseDir}/grapheditor/dist/viewer_iframe.html`; // 组态预览页
}
export { baseUrl, baseDir, imageBaseUrl, websocketUrl, graphEditorUrl, graphViewerUrl };
